export default __webpack_public_path__ + "static/media/key.5175d6fa.svg";